import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { InlineOverlay, InlineOverlayHeader, InlineOverlayFooter, InlineOverlayBody, InlineOverlayCloseButton } from '@bibliocommons/base-inline-overlay';
import { TransactionalButton } from '@bibliocommons/base-buttons';
import { Checkmark } from '@bibliocommons/base-icons';
import { GenericForm } from '@bibliocommons/shared-messages';
import BibBrief from '@bibliocommons/shared-bib-brief';
/* eslint-disable import/no-extraneous-dependencies */
import MessagingContainer from '../../../../../../containers/shared/Messaging/MessagingContainer';
/* eslint-enable import/no-extraneous-dependencies */
import DigitalFormats from '../../digital-formats';

export class DigitalMissingFormatWorkflowView extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      format: null
    };
    this.bindAll('handleFormatSelect', 'handleFormatLockIn');
  }

  handleFormatSelect(format) {
    this.setState({ format });
  }

  handleFormatLockIn() {
    const { format } = this.state;
    const { accountId, checkout, bib, messagingId, workflowId } = this.props;

    if (format) {
      this.props.lockInFormat({
        accountId,
        checkoutId: checkout.get('checkoutId'),
        format: format.get('name'),
        metadataId: bib.get('id'),
        messagingId,
        workflowId
      });
    }
  }

  render() {
    const { handleClose, bib, isLoading, formats, provider } = this.props;
    return (
      <InlineOverlay handleClose={handleClose}>
        <InlineOverlayHeader>
          <FormattedMessage id="digital_title_is_available" values={{ title: bib.get('title') }} />
        </InlineOverlayHeader>
        <InlineOverlayBody>
          <MessagingContainer id={bib.get('id')}>
            {
              messageOptions => <GenericForm {...messageOptions} />
            }
          </MessagingContainer>
          <BibBrief bib={bib} titleTag="h3" />
          <DigitalFormats
            formats={formats}
            provider={provider}
            selectable
            isAvailable
            onSelectFormat={this.handleFormatSelect}
            metadataId={bib.get('id')}
            fetchDigitalFormats={this.props.fetchDigitalFormats} />
        </InlineOverlayBody>
        <InlineOverlayFooter>
          <TransactionalButton data-test-id="missing-format-checkout-now" className="pull-right" isLoading={isLoading} handleClick={this.handleFormatLockIn} disabled={!this.state.format}>
            <Checkmark color="#FFF" /> <FormattedMessage id="check_out_now" />
          </TransactionalButton>
          <InlineOverlayCloseButton className="btn btn-link pull-right">
            <FormattedMessage id="button_nevermind_close" />
          </InlineOverlayCloseButton>
        </InlineOverlayFooter>
      </InlineOverlay>
    );
  }
}

DigitalMissingFormatWorkflowView.propTypes = {
  workflowId: PropTypes.string,
  messagingId: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  bib: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  isLoading: PropTypes.bool,
  formats: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    hasDownloadLink: PropTypes.bool
  })).isRequired,
  lockInFormat: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
  checkout: PropTypes.shape({
    checkoutId: PropTypes.string
  }).isRequired,
  provider: PropTypes.string,
  fetchDigitalFormats: PropTypes.func.isRequired
};

DigitalMissingFormatWorkflowView.displayName = 'DigitalMissingFormatWorkflowView';

export default DigitalMissingFormatWorkflowView;



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/digital-missing-format-workflow-view/components/DigitalMissingFormatWorkflowView.component.jsx